import React, { useEffect, useState, useMemo } from "react";
import ReactECharts from "echarts-for-react";

const API_URL = "https://api.pharmacegroup.co.uk/services_analysis";

const Services = () => {
 const token = localStorage.getItem("authToken");

  const [rawData, setRawData] = useState([]);
  const [loading, setLoading] = useState(false);
 
  // GRID MODE
  const [statusMode, setStatusMode] = useState("PENDING");

  // GRAPH FILTERS
  const [selectedPharmacy, setSelectedPharmacy] = useState("ALL");
  const [selectedService, setSelectedService] = useState("ALL");
  const [groupMode, setGroupMode] = useState("week");

  // ---------------- FETCH ----------------
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const members = JSON.parse(localStorage.getItem("members") || "[]");

        const organisationName = localStorage.getItem("organisationName") || "";

const allowedPharmacies =
  organisationName === "Pharmace all"
    ? ["xxx"]
    : members.map(m => m.pharmacyId);

const res = await fetch(API_URL, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify({ allowedPharmacies })
});

const json = await res.json();

 

        
        setRawData(json.data || []);
        
      } catch (err) {
        console.error("Error loading services:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  // ---------------- DERIVED ----------------
const pharmacies = useMemo(() => {
  return rawData
    .filter(p => {
      const hasPending = (p.services || []).some(s => (s.pendingCount || 0) > 0);

      const hasOther = (p.services || []).some(s =>
        (s.dailyStats || []).some(d =>
          (d.stats || []).some(st => st.count > 0)
        )
      );

      return hasPending || hasOther;
    })
    .map(p => p.pharmacyName)
    .sort((a, b) => a.localeCompare(b));
}, [rawData]);

  const services = useMemo(() => {
    const set = new Set();
    rawData.forEach(p =>
      (p.services || []).forEach(s => set.add(s.serviceName))
    );
    return Array.from(set).sort();
  }, [rawData]);

  // ---------------- GRID DATA ----------------
  const gridData = useMemo(() => {
    const grid = {};

    rawData.forEach(p => {
      grid[p.pharmacyName] = {};

      (p.services || []).forEach(s => {
        let total = 0;

        if (statusMode === "PENDING") {
          total = s.pendingCount || 0;
        } else {
          s.dailyStats.forEach(d => {
            d.stats.forEach(st => {
              if (st.status === statusMode) {
                total += st.count;
              }
            });
          });
        }

        grid[p.pharmacyName][s.serviceName] = total;
      });
    });

    return grid;
  }, [rawData, statusMode]);

  // ---------------- GRAPH DATA ----------------
const graphData = useMemo(() => {
  const pharmacy = selectedPharmacy;
  const service = selectedService;
  const group = groupMode;

  let filtered = [];

  rawData.forEach(p => {
    if (pharmacy !== "ALL" && p.pharmacyName !== pharmacy) return;

    (p.services || []).forEach(s => {
  if (
  service !== "ALL" &&
  s.serviceName.toLowerCase().trim() !== service.toLowerCase().trim()
) return;

      (s.dailyStats || []).forEach(d => {
        filtered.push({
          service: s.serviceName,
          date: d.date,
          stats: d.stats
        });
      });
    });
  });

  const grouped = {};

  const getKey = (dateStr) => {
    const [d, m, y] = dateStr.split("/");
    const dt = new Date(`${y}-${m}-${d}`);

    if (group === "day") return dateStr;
    if (group === "week") return `${m}/${y} W${Math.ceil(dt.getDate() / 7)}`;
    if (group === "month") return `${m}/${y}`;
    if (group === "year") return `${y}`;

    return dateStr;
  };

  filtered.forEach(item => {
    const key = getKey(item.date);

    if (!grouped[key]) {
      grouped[key] = { completed: 0, cancelled: 0 };
    }

    item.stats.forEach(st => {
      if (st.status === "COMPLETED") grouped[key].completed += st.count;
      if (st.status === "CANCELLED") grouped[key].cancelled += st.count;
    });
  });

const result = Object.entries(grouped).map(([date, vals]) => ({
  date,
  completed: vals.completed || 0,
  cancelled: vals.cancelled || 0
}));

console.log("GRAPH DATA:", result); // 👈 DEBUG

return result;
}, [selectedPharmacy, selectedService, groupMode, rawData]);
// ---------------- CHART SERIES ----------------
const chartSeries = useMemo(() => {

  if (!graphData.length) return [];

  return [
  {
    name: "Completed",
    type: "bar",
    stack: "total",   // 👈 ADD THIS
    data: graphData.map(d => d.completed),
    itemStyle: { color: "green" }
  },
  {
    name: "Cancelled",
    type: "bar",
    stack: "total",   // 👈 ADD THIS
    data: graphData.map(d => d.cancelled),
    itemStyle: { color: "red" }
  }
];

}, [graphData]);


const xAxis = graphData.map(d => d.date);
 
const chartOption = {
  tooltip: { trigger: "axis" },

  legend: {
    top: 0,
    data: chartSeries.map(s => s.name)
  },

  grid: {
    top: 80,
    left: 20,
    right: 20
  },

  xAxis: {
    type: "category",
    data: xAxis,
    axisLabel: { rotate: 45 }
  },

  yAxis: {
    type: "value"
  },

  series: chartSeries
};



// ---------------- UI ----------------
  return (
    <div style={{ padding: 10 }}>

      <h2>Services Analysis</h2>

      {/* STATUS BUTTONS */}
      <div style={{ marginBottom: 10 }}>
        {["PENDING", "COMPLETED", "CANCELLED"].map(s => (
          <button
            key={s}
            onClick={() => setStatusMode(s)}
            style={{
              marginRight: 10,
              padding: "6px 12px",
              background: statusMode === s ? "#3b82f6" : "#e5e7eb",
              color: statusMode === s ? "#fff" : "#000",
              border: "none",
              borderRadius: 4,
              cursor: "pointer"
            }}
          >
            {s}
          </button>
        ))}
      </div>



      {/* GRID */}
<div style={{ overflow: "auto", marginBottom: 20, maxHeight: 400 }}>
  <table style={{ borderCollapse: "collapse", minWidth: services.length * 120 }}>
          <thead>
            <tr>
             <th style={{
  border: "1px solid #ccc",
  padding: 6,
  position: "sticky",
  left: 0,
  background: "#fff",
  zIndex: 2
}}>
  Pharmacy
</th>
              {services.map(s => (
              <th key={s} style={{
  border: "1px solid #ccc",
  padding: 6,
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 1
}}>
                  {s}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pharmacies.map(p => (
              <tr key={p}>
              <td style={{
  border: "1px solid #ccc",
  padding: 6,
  position: "sticky",
  left: 0,
  background: "#fff",
  zIndex: 1
}}>
  {p}
</td>
                {services.map(s => (
                <td
  key={s}
  style={{
    border: "1px solid #ccc",
    padding: 6,
    textAlign: "center",
    background:
      (gridData[p]?.[s] || 0) > 0
        ? statusMode === "PENDING"
          ? "#fbbf24"     // amber
          : statusMode === "COMPLETED"
          ? "#86efac"     // green
          : statusMode === "CANCELLED"
          ? "#fecaca"     // light red
          : ""
        : ""
  }}
>
                    {gridData[p]?.[s] || 0}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        
            
      </div>

 {/* FILTERS */}
<div style={{
  display: "flex",
  gap: 10,
  marginBottom: 10,
  width: "100%"
}}>
  <select value={selectedPharmacy} onChange={e => setSelectedPharmacy(e.target.value)}>
    <option value="ALL">All pharmacies</option>
    {pharmacies.map(p => <option key={p}>{p}</option>)}
  </select>

  <select value={selectedService} onChange={e => setSelectedService(e.target.value)}>
    <option value="ALL">All services</option>
    {services.map(s => <option key={s}>{s}</option>)}
  </select>

  <select value={groupMode} onChange={e => setGroupMode(e.target.value)}>
    <option value="day">By day</option>
    <option value="week">By week</option>
    <option value="month">By month</option>
    <option value="year">By year</option>
  </select>
</div>


 
    
  {/* GRAPH */}
<div style={{
  marginTop: 40,
  border: "1px solid #ddd",
  padding: 10,
  background: "#fff"
}}>
  <div style={{
    overflowX: "auto",
    overflowY: "hidden"
  }}>
    <div style={{
      width: Math.max(800, xAxis.length * 80),
      height: 400
    }}>
   <ReactECharts
key={`${selectedPharmacy}-${selectedService}-${groupMode}`}  // 👈 FORCE FULL RE-RENDER
  option={chartOption}
  style={{ height: "100%", width: "100%" }}
/>
    </div>
  </div>
</div>

      {loading && <div style={{ marginTop: 10 }}>Loading...</div>}

    </div>
  );
};

export default Services;